import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';



import Button from '@mui/material/Button';


import CircularProgress from '@mui/material/CircularProgress';

import { green } from '@mui/material/colors';



const styles = theme => ({

    formControl: {
        margin: 0,
        width: '100%'
    },

    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12
    }

});

class AddReponseToSavGesteCommercial extends React.Component {


    render() {
        const { classes, onClickAccepter, onClickRefuser, onClickDemanderInformation, isAdding } = this.props;


        return (

            <>

                <Button
                    onClick={onClickAccepter}
                    variant="contained"
                    color="secondary"
                    disabled={isAdding}
                >
                    {isAdding === true && <CircularProgress size={24} className={classes.buttonProgress} />}
                Accepter
            </Button>


                <Button
                    onClick={onClickRefuser}
                    variant="contained"
                    color="secondary"
                    disabled={isAdding}
                >
                    {isAdding === true && <CircularProgress size={24} className={classes.buttonProgress} />}
                Refuser
            </Button>


                <Button
                    onClick={onClickDemanderInformation}
                    variant="contained"
                    color="secondary"
                    disabled={isAdding}
                >
                    {isAdding === true && <CircularProgress size={24} className={classes.buttonProgress} />}
                Demander plus d'information
            </Button>

            </>
        );
    }
}
AddReponseToSavGesteCommercial.propTypes = {
    onClickAccepter: PropTypes.func.isRequired,
    onClickRefuser: PropTypes.func.isRequired,
    onClickDemanderInformation: PropTypes.func.isRequired,


    isAdding: PropTypes.bool.isRequired
};

export default withStyles(styles)(AddReponseToSavGesteCommercial);